<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Usuários de Integração
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters align="center">
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-row align="center">
                <v-col v-if="nivelUsuarioApelido === 'I'">
                  <v-btn
                    color="cancel"
                    :disabled="salvando"
                    :loading="salvando"
                    @click="openDialogAddIntegradorByUsuario()"
                  >
                    Vincular usuário
                  </v-btn>
                </v-col>
                <v-col>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls()">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="exportPdf()">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" :loading="salvando" :disabled="salvando" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" :loading="salvando" :disabled="salvando" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="700px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usuario.uuid_uap_id ? 'Editar usuário' : 'Novo usuário'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsuarios">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-combobox
                v-model="usuario.usinas"
                :menu-props="{ offsetY: true}"
                :items="usinas"
                :search-input.sync="searchUsina"
                hide-selected
                label="Usinas"
                multiple
                clear-icon="close"
                append-icon="expand_more"
                :loading="salvando || loadingUsinas"
                :disabled="salvando || loadingUsinas"
                @keyup="buscaUsinas()"
                outlined
                small-chips
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    v-if="item.text"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      close
                    </v-icon>
                  </v-chip>
                </template>
                <template v-slot:no-data>
                  <v-list-item v-if="searchUsina === ''">
                    <v-list-item-content>
                      <v-list-item-title>
                        Nenhnum resultado encontrado com "<strong>{{ searchUsina }}</strong>".
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0" v-if="nivelUsuarioApelido === 'M'">
              <v-autocomplete
                class="mb-2"
                :rules="[rules.required]"
                :menu-props="{ offsetY: true}"
                :items="distribuidores"
                label="Distribuidor*"
                append-icon="expand_more"
                v-model="usuario.uuid_dis_id"
                hide-details=""
                :loading="loading || loadingDistribuidores"
                :disabled="loading || loadingDistribuidores"
                outlined
                clearable
                clear-icon="close"
                @change="usuario.uuid_dis_id ? getIntegradores(usuario.uuid_dis_id, true) : integradoresCadastro = []"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
              <v-autocomplete
                class="mb-2"
                :rules="[rules.required]"
                :menu-props="{ offsetY: true}"
                :items="integradoresCadastro"
                label="Integrador*"
                append-icon="expand_more"
                v-model="usuario.uuid_int_id"
                hide-details=""
                :loading="loading || loadingIntegradores"
                :disabled="loading || loadingIntegradores"
                outlined
                clearable
                clear-icon="close"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="usuario.uap_login"
                label="Login*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usuario.uap_integration"
                :items="['Alexa', 'APP', 'Google']"
                label="Integração*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                @click:append="show1 = !show1"
                :label="usuario.uuid_uap_id ? 'Preencha caso desejar alterar a senha' : 'Senha'"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                :loading="salvando"
                :disabled="salvando"
                :type="show1 ? 'text' : 'password'"
                v-model="usuario.uap_password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="usuario.uuid_uap_id ? [] : usuario.uap_password.length > 0 ? [rules.min] : []"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-textarea
                outlined
                no-resize
                rows="3"
                v-model="usuario.uap_parameters"
                label="Parâmetros adicionais"
                :disabled="salvando"
                :loading="salvando"
              ></v-textarea>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUser()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Usuário <b class="text-primary">{{usuario ? usuario.uap_login : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddIntegradorByUsuario" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Vincular usuário ao integrador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogAddIntegradorByUsuario()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Informe o código do usuário
        </div>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
            <v-text-field
              label="Informe o código do usuário"
              outlined
              :loading="salvando"
              :disabled="salvando"
              type="text"
              v-model="usuarioCodigo"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogAddIntegradorByUsuario()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando || !usuarioCodigo"
            :loading="salvando"
            @click="addIntegradorByUsuario()"
          >
            Vincular
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import _debounce from 'lodash.debounce'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  data () {
    return {
      total: 0,
      carregando: false,
      options: {},
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogAddIntegradorByUsuario: false,
      usuarioCodigo: '',
      search: '',
      searchFinal: null,
      show1: false,
      searchUsina: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'uap_id'
        },
        { text: 'Login', value: 'uap_login' },
        { text: 'Integração', value: 'uap_integration' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres'
      },
      usinas: [],
      loadingUsinas: false,
      usuario: {
        uap_login: '',
        uap_password: '',
        uap_integration: '',
        usinas: []
      },
      distribuidor: '',
      distribuidorAnterior: '',
      distribuidores: [],
      loadingDistribuidores: false,
      integrador: '',
      integradores: [],
      integradoresCadastro: [],
      loadingIntegradores: false,
      user: '',
      nivelUsuarioApelido: ''
    }
  },
  watch: {
    search (val) {
      this.serchField = val
    },
    options: {
      handler () {
        this.getUsers(this.distribuidor, this.integrador)
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        type: 'usuarios-integracao'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Usuários de Integração', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }
      this.loadFunctions(this.distribuidor, this.integrador)
    },
    loadFunctions (dist, int) {
      // this.getUsinas()
      this.getIntegradores()
      this.getDistribuidores()
      this.getUsers(dist, int)
      this.loading = false
    },
    buscaUsinas: _debounce(function () {
      if (this.searchUsina.length <= 3) return
      this.getUsinas()
    }, 500),
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'ConfiguracoesAppUsuarios', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getUsers(this.distribuidor, this.integrador)
    },
    async getIntegradores (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }

          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async addIntegradorByUsuario () {
      this.salvando = true
      let endpoint = `usuarios-app/${this.usuarioCodigo}/add-integrador`
      Api.patch(endpoint)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Integrador vinculado ao usuário com sucesso!',
            color: 'success'
          })
          this.closeDialogAddIntegradorByUsuario()
          this.getUsers()
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    async getUsinas () {
      this.loadingUsinas = true
      await Api.get('usinas?busca=' + this.searchUsina)
        .then(res => {
          var arrayUsi = []
          res.data.map(usi => {
            arrayUsi.push({
              'text': usi.usi_nome,
              'value': usi.uuid_usi_id
            })
          })
          this.usinas = arrayUsi
          this.loadingUsinas = false
        })
        .catch(err => {
          this.loadingUsinas = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as usinas!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getUsers (dist = false, int = false) {
      this.carregando = true
      this.dados = []
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      let endpoint = ''
      if (dist) {
        endpoint += '&distribuidor=' + dist
      }
      if (int) {
        endpoint += '&integrador=' + int
      }
      if (this.searchFinal) {
        endpoint += '&busca=' + this.searchFinal
      }
      await Api.get(`usuarios-app?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data.data && res.data.data.length > 0) {
            this.dados = res.data.data
          }
          console.log(res.data.data)
          this.total = res.data.total
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditUser () {
      if (!this.$refs.formUsuarios.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let dados = JSON.parse(JSON.stringify(this.usuario))
      if (dados.usinas.length > 0) {
        let usis = []
        dados.usinas.map(mod => {
          if (mod.value) {
            usis.push({
              'uuid_usi_id': mod.value
            })
          }
        })
        dados.usinas = usis
      }
      let endpoint = 'usuarios-app/novo'
      let editado = false
      if (dados.uuid_uap_id) {
        endpoint = 'usuarios-app/edita'
        editado = true
      }
      Api.post(endpoint, dados)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getUsers()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`usuarios-app/remove/${this.usuario.uuid_uap_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getUsers()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover usuário!',
            color: 'error'
          })
        })
    },
    async openNovo (item) {
      this.salvando = true
      await Api.get('usuarios-app/' + item.uuid_uap_id)
        .then(res => {
          this.usuario = JSON.parse(JSON.stringify(res.data))
          this.usuario = {
            ...this.usuario,
            uuid_int_id: this.usuario.integrador ? this.usuario.integrador.uuid_int_id : null,
            uuid_dis_id: this.usuario.distribuidor ? this.usuario.distribuidor.uuid_dis_id : null
          }

          delete this.usuario.uap_password

          if (this.usuario.usinas.length) {
            let usis = []
            this.usuario.usinas.map(mod => {
              usis.push({text: mod.usi_nome, value: mod.uuid_usi_id})
            })
            this.usuario.usinas = usis
          }
          if (this.usuario.uuid_dis_id) {
            this.getIntegradores(this.usuario.uuid_dis_id, true)
          }

          this.salvando = false
        })
        .catch(err => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o usuário!',
            color: 'error'
          })
          console.log(err)
        })
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.usuario = {
        uap_login: '',
        uap_password: '',
        uap_integration: '',
        usinas: []
      }
      if (this.$refs.formUsuarios) {
        this.$refs.formUsuarios.resetValidation()
      }
      this.dialogNovo = false
    },
    openDialogAddIntegradorByUsuario () {
      this.dialogAddIntegradorByUsuario = true
    },
    closeDialogAddIntegradorByUsuario () {
      this.dialogAddIntegradorByUsuario = false
      this.usuarioCodigo = ''
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/ConfigAppUsuarios.vue